import { render, staticRenderFns } from "./Kusama.vue?vue&type=template&id=0bc5c5fc&scoped=true&"
import script from "./Kusama.vue?vue&type=script&lang=js&"
export * from "./Kusama.vue?vue&type=script&lang=js&"
import style0 from "./Kusama.vue?vue&type=style&index=0&id=0bc5c5fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc5c5fc",
  null
  
)

export default component.exports